export const cameraView01HullColorImageOptions = {
  legacy: true,
  prefix: 'X4_9_Exterior',
  angle: 'Camera View 01 - Hull color',
  staticOptions: {
    TeakOnBathingPlatform: 1,
    Boom: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/CameraView01HullColor.js